import { createFileRoute, useRouteContext, useRouter } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { useState, type JSX } from "react";
import { CpsToast } from "corpus";
import { Button } from "@/components/ui/button/button";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page, PageSection, PageTitle } from "@/components/ui/layout/page/page";
import { trackEvent } from "@/lib/tracking";
import { ICON_MAP } from "@/lib/constants/fake-door-home-icons";

const ConfirmationPage = (): JSX.Element => {
  const [showConfirmationToast, setShowConfirmationToast] = useState(false);
  const { infoItemId } = Route.useParams();
  const router = useRouter();

  const { flags } = useRouteContext({ from: "__root__" });
  const CONFIRMATION_FF_JSON = flags["textos-confirmacao-rota-info-home"];

  const confirmation = CONFIRMATION_FF_JSON
    ? CONFIRMATION_FF_JSON[infoItemId]
    : undefined;

  if (!confirmation) {
    return (
      <>
        <HeaderRoot>
          <HeaderButton icon={Left} align="start" />
          <HeaderTitle title="Página não encontrada" align="center" />
        </HeaderRoot>
        <Page>
          <PageSection className="px-4 flex flex-col gap-6 h-full">
            <div className="flex flex-col items-center justify-center gap-6 text-center">
              <p>Página de confirmação não encontrada.</p>
            </div>
          </PageSection>
        </Page>
      </>
    );
  }

  const handleWaitlistClick = (): void => {
    trackEvent(confirmation.eventName, confirmation.eventProps);
    setShowConfirmationToast(true);

    setTimeout(() => {
      void router.navigate({ to: "/home" });
    }, 5000);
  };

  const IconComponent =
    confirmation.iconName in ICON_MAP
      ? ICON_MAP[confirmation.iconName as keyof typeof ICON_MAP]
      : null;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title={confirmation.title} align="center" />
      </HeaderRoot>
      <Page>
        <PageSection className="p-4 flex flex-col gap-6 h-full">
          <div className="flex flex-col items-center justify-center gap-6 text-center">
            {IconComponent ? (
              <IconComponent size={76} className="fill-secondary-500" />
            ) : null}

            <div className="flex flex-col gap-4">
              <PageTitle className="text-center text-lg leading-relaxed">
                {confirmation.pageTitle}
              </PageTitle>

              <p className="text-neutral-600 text-base">{confirmation.description}</p>
            </div>
          </div>

          <Button fullWidth onClick={handleWaitlistClick}>
            {confirmation.buttonText}
          </Button>

          <CpsToast
            title="Sucesso!"
            description="Você entrou na fila de espera."
            show={showConfirmationToast}
            onClose={() => setShowConfirmationToast(false)}
            type="success"
            duration={10}
          />
        </PageSection>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/home/info/$infoItemId/confirmation")({
  component: ConfirmationPage,
});
